/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Export_No_GpsInputs */

const en_toast_export_no_gps = /** @type {(inputs: Toast_Export_No_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No GPS data to export`)
};

const de_toast_export_no_gps = /** @type {(inputs: Toast_Export_No_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine GPS-Daten zum Exportieren`)
};

/**
* | output |
* | --- |
* | "No GPS data to export" |
*
* @param {Toast_Export_No_GpsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_export_no_gps = /** @type {((inputs?: Toast_Export_No_GpsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Export_No_GpsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_export_no_gps(inputs)
	return de_toast_export_no_gps(inputs)
});